import type { TextReportSection } from "../../api/types";

export function TextSection({ section }: { section: TextReportSection }) {
  const hasObject = section.obj !== null && section.obj !== undefined;
  return <section className="fa-report-section" id={String(section.sectionId)}>{section.sectionTitle ? <h3>{section.sectionTitle}</h3> : null}<p className="fa-report-paragraph">{section.conclusion}</p>{hasObject && <div className="fa-report-extension"><strong>扩展数据</strong><span>{typeof section.obj === "object" ? JSON.stringify(section.obj) : String(section.obj)}</span></div>}</section>;
}
